<template>
    <div id="category_list" class="section_list_wrapper">
        <div class="row">
            <div class="col-md-3" v-for="(card, key) in lists" :key="key">
                <div class="card_wrapper bt_border img_right">
                    <a :href="'/article/' + card.nid" class="card_img_wrapper">
                        <img class="card_img" :src="imgHost+ '?w=346&h=230&resize=fill&g=ce&url=' +card.article_image_origin" :alt="card.article_image_description">
                    </a>
                    <div class="card_content_wrapper">
                        <div class="card_tags_wrapper">
                            <a href="javascript:void(0);" class="card_tag keyword">{{ card.ireview_text }}</a>
                        </div>
                        <a :href="'/article/' + card.nid" class="card_title">{{ $parent.stripLength(card.article_title, 29) }}</a>
                        <p class="card_desc">{{ $parent.stripLength(card.article_brief, 41) }}</p>
                        <div class="card_info_wrapper">
                            <div class="card_info_content authors">
                                <span class="author_text">By</span>
                                <a :href="'/author/' + card.article_authors_id[0]" class="author_link">{{ card.article_authors[0] }}</a>
                            </div>
                            <span class="card_info_content publish_time">{{ $parent.convertTimestampToFormat(card.article_date_publish) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img src="/images/ajax-loader.gif" class="loading_indicator" alt="" v-show="loading">
    </div>
</template>

<script>
    export default {
        props: {
            cards: {
                type: Array
            },
            loading: {
                type: Boolean
            },
            imgHost: {
               type: String
            }
        },
        data() {
            return {}
        },
        computed: {
            lists() {
                return this.cards;
            }
        }
    }
</script>
